var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"light"},[(_vm.ping && _vm.value)?_c('div',{staticClass:"light__ping",class:_vm.lightCss}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"light__dot",class:_vm.lightCss})])
}
var staticRenderFns = []

export { render, staticRenderFns }